import { render } from "./BadgeFacturas.vue?vue&type=template&id=11041a85"
import script from "./BadgeFacturas.vue?vue&type=script&lang=js"
export * from "./BadgeFacturas.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__